import MessageBox from './src/main.js';
export default MessageBox;



// WEBPACK FOOTER //
// ./~/vue-xpc/src/element-ui/packages/message-box/index.js